import { useSmartAccounts } from '~/hooks/useSmartAccounts'
import { GasPaidBy } from '~/types'

// Names who covered a transaction's gas. Plan-sponsored gas is simply
// "Splits": the plan's name is not shown.
export const useGasPaidByLabel = (transaction: {
  gasPaidBy?: GasPaidBy
  smartAccountId: string
}): string | undefined => {
  const { smartAccounts } = useSmartAccounts()

  switch (transaction.gasPaidBy) {
    case 'plan':
      return 'Splits'
    case 'gas_balance':
      return 'Gas balance'
    case 'self':
      return (
        smartAccounts.find(
          (account) => account.id === transaction.smartAccountId,
        )?.name ?? 'Account'
      )
    default:
      return undefined
  }
}
